export const API_URL = process.env.REACT_APP_API_URL; //'https://ggenomics-api-80db013ef385.herokuapp.com/api';
